$(document).ready(function () {
    var scroll,
    currentScrollTop = 0,
    navbar = $('.js-nav-scroll');
  
    if(window.innerWidth >= 768) {
      $(window).scroll(function () {
        var a = $(window).scrollTop();
        var b = navbar.height() - 100;
        currentScrollTop = a;

        if (scroll < currentScrollTop && a > b + b) {
          navbar.addClass("scroll-up");
          navbar.removeClass("scroll-down");
        } else if (scroll > currentScrollTop && !(a <= b)) {
          navbar.removeClass("scroll-up");
          navbar.addClass("scroll-down");
        } else if (currentScrollTop < 250) {
            navbar.removeClass('scroll-up, scroll-down');
        }
        scroll = currentScrollTop;
    });
    }
});

